import { PointCloudStylingIntensityGradient } from '@trimble/types';

export const POINT_CLOUD_INTENSITY_DEFAULTS: PointCloudStylingIntensityGradient =
  {
    startColor: '#000000',
    endColor: '#ffffff',
    offset: 0.5,
  };

export interface PointCloudIntensityControlProps
  extends PointCloudStylingIntensityGradient {
  onGradientChange?(gradient: PointCloudStylingIntensityGradient): void;
}
